module.exports = __webpack_public_path__ + "img/baseball_field.1d65a6f6.png";